import dateFns from './date-fns-methods'
import * as methods from './methods'

export default {
  ...dateFns,
  ...methods
}
